export default __webpack_public_path__ + "static/media/QuestionBank.611b2e05.svg";